import { render, staticRenderFns } from "./totalScore.vue?vue&type=template&id=85bbd22c&"
import script from "./totalScore.vue?vue&type=script&lang=js&"
export * from "./totalScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports